export const URL_CHECKOUT_AUTHENTICATION = '/signup';
